import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <MainFeature1
        subheading={<Subheading>About Help yourself goals</Subheading>}
        heading="Empowering Your Wellness Journey"
        buttonRounded={false}
        primaryButtonText="See Portfolio"
        imageSrc="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        description="At Help Yourself, our goal is to guide you towards a healthier and more balanced lifestyle through personalized nutrition and wellness plans. We believe that good nutrition is the cornerstone of a happy and vibrant life. Our mission is to empower you with the knowledge, tools, and support you need to make informed decisions about your health and well-being..."
      />
      <MainFeature1
        subheading={<Subheading>Our Vision</Subheading>}
        heading="A Healthier Tomorrow"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        imageSrc="https://images.unsplash.com/3/doctype-hi-res.jpg?ixlib=rb-1.2.1&auto=format&fit=crop&w=768&q=80"
        textOnLeft={false}
        description="At Help Yourself, our vision is to create a world where everyone has access to the knowledge and resources they need to live their healthiest life. We aspire to be the go-to destination for personalized nutrition and wellness guidance, empowering individuals"
      />
      <Features
        subheading={<Subheading>Our Values</Subheading>}
        heading="We follow these."
        description="We uphold the highest standards of honesty and transparency in everything we do, ensuring that our clients receive trustworthy and reliable advice."
        cards={[
          {
            imageSrc: SupportIconImage,
            title: "24/7 Support",
            description: "Our dedicated team is here for you around the clock, ready to assist whenever you need us."
          },
          {
            imageSrc: ShieldIconImage,
            title: "Strong Teams",
            description: "We believe in the power of collaboration, fostering strong, skilled teams to deliver exceptional results."
          },
          {
            imageSrc: CustomerLoveIconImage,
            title: "Customer Satisfaction",
            description: "Your happiness is our priority; we strive to exceed your expectations with every interaction."
          },
        ]}
        linkText=""
      />
      <TeamCardGrid 
        subheading={<Subheading>Our Team</Subheading>}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
